@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.drivertargets

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.drivertargets.ExtendedTargetDto
import com.narbase.letsgo.web.models.TargetsStatus

object GetTargetsEndpoint : EndPoint<GetTargetsEndpoint.Request, GetTargetsEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
        @Suppress("NON_EXPORTABLE_TYPE") val targetStatus: DtoName<TargetsStatus>?,
    )

    class Response(
        val extendedTargets: Array<ExtendedTargetDto>,
        val total: Int
    )
}